import useUserStore from '@/stores/userStore';
import HandleLogin from './handle-login';
import AvatarCard from './avatar-card';

export default function UserProfile() {
  const { user, loading } = useUserStore();

  if (loading) {
    return <></>;
  }

  if (!user) {
    return <HandleLogin />;
  }

  return <AvatarCard />;
}
